import React from 'react'
import { Typography } from '@repo/ui/components/typography'
import { useTranslate } from '@repo/shared/hooks'
import { type CSSVariableColor } from '@repo/ui/types/colors'
import { cn } from '@repo/ui/lib'

interface IMeterSquareProps {
  value: string | number
  size?: '2xs' | 'xs' | 'sm' | 'md' | 'xl' | '2xl' | '3xl'
  numberSize?: '2xs' | 'xs' | 'sm' | 'md' | 'xl' | '2xl' | '3xl'
  numberColor?: CSSVariableColor | undefined
  color?: CSSVariableColor | undefined
  isBold?: boolean
  isLatin?: boolean
  isCentimeter?: boolean
  isCrypto?: boolean
  approximately?: boolean
  className?: string
}

const formatNumberWithCommas = (
  _value: number | string | undefined,
): string => {
  const value = _value?.toString()
  if (!value) {
    return ''
  }
  if (value?.startsWith('.')) {
    return '0.'
  }

  const [firstPart = '', ...parts] = value.toString().split('.')
  const formatted = firstPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return [formatted, ...(parts || [])].join('.')
}

export const MeterSquare = (props: IMeterSquareProps) => {
  const {
    value,
    size = '2xs',
    numberSize = '2xs',
    numberColor = 'text-neutral-surface-100',
    color = 'text-neutral-surface-80',
    isBold = true,
    isLatin = false,
    isCentimeter = true,
    isCrypto = false,
    approximately = false,
    className,
  } = props
  const { tRich } = useTranslate()
  return (
    <Typography
      variant='span'
      size={size}
      weight='regular'
      color={color}
      className={cn('whitespace-nowrap', className)}
    >
      {tRich.rich(
        isCrypto
          ? 'common_token2'
          : isLatin
            ? isCentimeter
              ? 'CM2_value'
              : 'MM2_value'
            : isCentimeter
              ? 'common_centimeter_square'
              : 'common_meter_square',
        {
          value: () => (
            <Typography
              variant='span'
              size={numberSize}
              weight={isBold ? 'bold' : 'regular'}
              color={numberColor}
            >
              {formatNumberWithCommas(value)}
              {approximately ? '~' : ''}
            </Typography>
          ),
        },
      )}
    </Typography>
  )
}
